import { useGetList } from "ra-core";

import type { Contact, ContactNote } from "../types";
import { DashboardActivityLog } from "./DashboardActivityLog";
import { DashboardMetrics } from "./DashboardMetrics";
import { DashboardStepper } from "./DashboardStepper";
import { FunnelOverview } from "./FunnelOverview";
import { HotContacts } from "./HotContacts";
import { TasksList } from "./TasksList";

export const Dashboard = () => {
  const { data: contacts, total: contactCount } = useGetList<Contact>(
    "contacts",
    { pagination: { page: 1, perPage: 1 } },
  );
  const { total: noteCount } = useGetList<ContactNote>("contact_notes", {
    pagination: { page: 1, perPage: 1 },
  });
  return (
    <div className="flex flex-col gap-6">
      <DashboardMetrics />
      <FunnelOverview />

      {!contactCount ? (
        <DashboardStepper step={1} />
      ) : !noteCount ? (
        <DashboardStepper step={2} contactId={contacts?.[0]?.id} />
      ) : (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
          <div className="md:col-span-3">
            <HotContacts />
          </div>
          <div className="flex flex-col gap-6 md:col-span-6">
            <DashboardActivityLog />
          </div>
          <div className="md:col-span-3">
            <TasksList />
          </div>
        </div>
      )}
    </div>
  );
};
